import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Info } from 'lucide-react';

const PriceEstimate = ({ tripType, distance, hours, price, details }) => {
  const isLocationBased = tripType === 'One Way' || tripType === 'Wait & Return';
  const isTimeBased = tripType === 'Hourly' || tripType === 'As Directed';

  return (
    <div className="lg:col-span-1">
      <Card className="bg-brand-charcoal border-brand-gold/20 p-4 sm:p-6 lg:p-8 sticky top-20 sm:top-24">
        <CardHeader className="pb-4 sm:pb-6"><CardTitle className="text-2xl sm:text-3xl font-serif text-white">Price Estimate</CardTitle></CardHeader>
        <CardContent className="space-y-3 sm:space-y-4">
          {isLocationBased && (
            <div>
              <Label htmlFor="distance" className="text-base sm:text-lg">Estimated Distance (miles)</Label>
              <Input id="distance" type="text" placeholder="Select locations to see" className="mt-2 h-10 sm:h-12 text-sm sm:text-lg" value={distance || ''} readOnly/>
            </div>
          )}
          {isTimeBased && (
            <div className="text-center">
              <Label className="text-base sm:text-lg">Duration</Label>
              <p className="text-2xl sm:text-3xl font-bold text-white mt-2">{hours} Hour(s)</p>
            </div>
          )}

          <div className="text-center py-4 sm:py-6 border-y-2 border-brand-gold/20">
            <p className="text-gray-400 text-base sm:text-lg">Estimated Fare</p>
            <p className="text-3xl sm:text-4xl lg:text-5xl font-bold text-brand-gold">${price || '0.00'}</p>
            {details && <p className="text-brand-gold/80 text-xs sm:text-sm mt-2">{details}</p>}
          </div>
          <div className="text-xs sm:text-sm text-gray-400 flex">
            <Info className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10 mr-2 text-brand-gold flex-shrink-0" />
            <p>Estimates are subject to change. For hourly, wait & return, and as-directed trips, pricing is based on vehicle type and time. Final quote will be confirmed after submission.</p>
          </div>
          
          {/* Distance-based pricing disclaimer */}
          {isLocationBased && distance > 15 && (
            <div className="mt-4 p-3 bg-yellow-900/20 border border-yellow-400/30 rounded-lg">
              <p className="text-xs sm:text-sm text-yellow-300 font-medium mb-2">
                📍 Long Distance Pricing Applied
              </p>
              <p className="text-xs text-yellow-200">
                For trips over 15 miles: SUV = $3.50/mile, Sedan = $3.00/mile
              </p>
            </div>
          )}
          
        </CardContent>
      </Card>
    </div>
  );
};

export default PriceEstimate;